/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileDwg = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M14.414 2H4v20h16V7.586zM6 16.5V4h3v11H7.5v1.5zm0 1h1.5V19H9v1H6zm4 2.5v-1h1.5v-1.5H18V20zm8-3.5h-6.5V15H10V4h3v5h5zM15 7V5.414L16.586 7zM8.5 18v-2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileDwg as FileDwg };
